<template>
  <div class="component-container">
    <h3>MSENG1 History of Earth - Downloads and Resources</h3>
    <div class="back-button-wrapper">
      <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
    </div>
    <div class="presentations">
      <h4>Teacher Presentations</h4>
      <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202025%20Updates%2FMSENG1_Activities1-7_updated_08242026.zip?alt=media&token=835d0728-bbae-4f54-aa9a-ba8baadb5796" target="_blank">Activities 1-7 (Zip File) - Updated 8-24-2026</a></li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
      </ul>
    </div>
    <div class="presentations">
      <h4>Student Journals</h4>
      <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/1Twb5PO6s8YfBRAqP-Lm96J49HUFVxNiDU9VP-hwzS4w/copy" target="_blank">MSENG1 History of Earth Student Journal (updated 09-08-2020)</a></li>
        <li><a href="https://drive.google.com/file/d/1Tvrt7laOM565F7nOtJtvGRLGsQYRSMDj/view" target="_blank">MSENG1 History of Earth Student Journal Answer Key</a></li>
        <li><a href="https://drive.google.com/file/d/1lxj_E-Z-_7aU7fKCq1fOXcw0Aaxt9Wr-/view?usp=sharing" target="_blank">MSENG1 History of Earth Student Journal Page 47 (for journals downloaded before 09-08-2020)</a></li>
      </ul>

    </div>
    <div class="presentations">
      <h4>Individual Resources</h4>
      <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1uf4_n4yKccRpnc97mhDUQNLic4INF-K_mKtql6uC72o/copy" target="_blank">What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1ih8ikzjRo2LvbSHkGLB7AOHKwgulwa4S7o9TL8Udgk0/copy" target="_blank">Anchor Charts</a></li>
          <li><a href="https://docs.google.com/presentation/d/1_21RTAAgSKI-o8Aj5syvM5JcWVmYuWHfCrl5DT11Jpk/copy" target="_blank">Mapping Earthquakes (Handout)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1BykqrYA2ooG2m3NOmwEUdL9rolEfAWQGm_GA--LAX3k/copy" target="_blank">Word Sort Cards - Lesson 2C</a></li>
          <li><a href="https://docs.google.com/presentation/d/1PiySA4PIUQ0pXh2AtFdYuYhTI1VdH9GaXJc4UzI2DxI/copy" target="_blank">Word Sort Cards - Lesson 2D</a></li>
          <li><a href="https://docs.google.com/presentation/d/129FlKbY3ijrdF1cziUYquYGJIjvsPpGhtoB4tolplCY/copy" target="_blank">Seismograph Product Descriptor Template</a></li>
          <li><a href="https://docs.google.com/presentation/d/1lM-6aSs_YGxZNopPHnsZIbK29XX4MyEK-xkVdaS38fo/copy" target="_blank">Fossils Help Put the Pieces Together (Handouts)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1hkk15D-16sIYxo75JflRf4VgRCP1BJznBUwc3IGJs2k/copy" target="_blank">Grand Canyon and Grand Canyon Cross-section</a></li>
          <li><a href="https://docs.google.com/presentation/d/1bMxnVUB5-7zB7ZsZJ8HOvlBlvXFe5xRrJKKG_hSxnKI/copy" target="_blank">Stratification Succession in Michigan</a></li>
          <li><a href="https://docs.google.com/presentation/d/1bnWc92yxvGzrsgQBAaUugh_-3-YtvLbcmSipW8ZIkL4/copy" target="_blank">Rock Layers and Fossils</a></li>
          <li><a href="https://docs.google.com/presentation/d/18egoWBmtAbEbY-bDMqEU6C8p8GU3RE9RlF-yUEcy2Bs/copy" target="_blank">Fossils (7B)</a></li>
          <li><a href="https://docs.google.com/presentation/d/1OKu33tKfJQ-BqkkujZvWEa6YnSRIJmdwjholTwZFwzw/copy" target="_blank">Word Sort Cards - Lesson 7B</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
